'use strict';

/* exported materialAdmin */
var materialAdmin = angular.module('materialAdmin', []); // eslint-disable-line
module.exports = materialAdmin;
